export enum PaymentAuthorizationChannel {
  Unknown = 'Unknown',
  Website = 'Website',
  Phone = 'Phone',
  Mail = 'Mail',
  Email = 'Email',
  Mobile = 'Mobile',
  Prearranged = 'Prearranged',
  PointOfPurchase = 'PointOfPurchase',
}
